import { render, staticRenderFns } from "./riderprize.vue?vue&type=template&id=e8bf23d6&"
import script from "./riderprize.vue?vue&type=script&lang=js&"
export * from "./riderprize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports